export const name = "zh-CN";
export const maintainer = "real186 <i@186526.xyz>";
export const context = {
  userName: "用户名",
  uuid: "UUID",
  changePassword: "修改密码",
  password: "密码",
  forgetPassword: "忘记密码",
  signIn: "登陆",
  changeSkin: "修改皮肤",
  register: "注册",
  notHaveAccount: "没有帐号"
};
